import React from 'react';
import { useDispatch } from 'react-redux';
import Users from './components/users';
import { setGetMailingStatisticsScrollerUsersOpenGame } from '../../../../../store/mailing/thunk/setGetMailingStatisticsScrollerUsersOpenGame';

const OpenGame = ({
    id
}) => {
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetMailingStatisticsScrollerUsersOpenGame({
            mailing_id: id,
            page: 1,
            pageSize: 25
        }))
    }, [])

    return (
        <div>
            <div>
                <h3 style={{
                    color: "#FFFFFF",
                    fontWeight: 700,
                }}>Открытые игры</h3>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                <Users mailing_id={id} />
            </div>

        </div >
    )
}

export default OpenGame;